export enum Permission {
  CAN_MANAGE_USERS = 'can_manage_users',
  CAN_ACCESS_TERMINAL_ATTENDANCE = 'can_access_terminal_attendance',
  CAN_CREATE_USERS = 'can_create_users',
  CAN_GENERATE_ATTENDANCE_REPORT = 'can_generate_attendance_report',
}
